'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import { attachQueryParamToUrl } from '../Utils/helpers.js';
import { SUCCESS_CODE } from './constants.js';

var getHotKeywords = function (msBaseUrl, rawUserId, language) {
    if (language === void 0) { language = 'vi'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var userId, apiUrl, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = rawUserId !== undefined && rawUserId !== null && rawUserId !== -1 ? rawUserId : 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v1/hot-keywords?userId=").concat(userId, "&lang=").concat(language);
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/vnd.api+json',
                                Accept: 'application/vnd.api+json',
                                'Accept-Language': language
                            }
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    // TODO: Log Error To Sentry
                    console.debug('error getHotKeywords', err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, { data: [] }];
            }
        });
    });
};
var getSearchBarHighLight = function (msBaseUrl, jobFunctionIds, lang) { return __awaiter(void 0, void 0, void 0, function () {
    var URL, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = attachQueryParamToUrl("".concat(msBaseUrl, "/banners/v1.0/searchbar-highlight"), {
                    jobFunctionIds: jobFunctionIds
                });
                return [4 /*yield*/, fetch(URL, {
                        method: 'GET',
                        headers: {
                            'Accept-Language': lang,
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getSuggestionKeyword = function (msBaseUrl, keyword, language, limit) { return __awaiter(void 0, void 0, void 0, function () {
    var encodedKeyword, apiUrl, suggestions, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedKeyword = encodeURIComponent(keyword);
                apiUrl = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion?query=").concat(encodedKeyword, "&limit=").concat(limit, "&lang=").concat(language);
                suggestions = {
                    data: []
                };
                if (keyword === '') {
                    return [2 /*return*/, suggestions];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json',
                            'Accept-Language': language
                        }
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                err_2 = _a.sent();
                // TODO: Log Error To Sentry
                console.debug('error getHotKeywords', err_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, suggestions];
        }
    });
}); };
var EMPTY_RESPONSE = {
    data: [],
    facets: {},
    meta: {
        code: 400,
        message: '',
        nbHits: 0,
        page: 0,
        nbPages: 0,
        hitsPerPage: 0
    }
};
var getSearchJob = function (msBaseUrl, postData) { return __awaiter(void 0, void 0, void 0, function () {
    var URL_1, onlyAddText, response, responseData, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                URL_1 = "".concat(msBaseUrl, "/job-search/v1.0/search");
                onlyAddText = localStorage.getItem('onlyAddText');
                if (!!onlyAddText) return [3 /*break*/, 3];
                return [4 /*yield*/, fetch(URL_1, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Source': 'Page-Container'
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                if (!(response.status === SUCCESS_CODE)) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _a.sent();
                return [2 /*return*/, responseData !== null && responseData !== void 0 ? responseData : EMPTY_RESPONSE];
            case 3: return [2 /*return*/, EMPTY_RESPONSE];
            case 4:
                ex_1 = _a.sent();
                console.error(ex_1);
                return [2 /*return*/, EMPTY_RESPONSE];
            case 5: return [2 /*return*/];
        }
    });
}); };
var trackSuggestionKeywords = function (_a) {
    var msBaseUrl = _a.msBaseUrl, language = _a.language, body = _a.body;
    return __awaiter(void 0, void 0, void 0, function () {
        var URL_2, err_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    URL_2 = "".concat(msBaseUrl, "/hot-keywords/api/v2/keywords/suggestion");
                    return [4 /*yield*/, fetch(URL_2, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': language
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _b.sent();
                    // TODO: Log Error To Sentry
                    console.error('error track suggestion keyword', err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
var getJobYouWillLove = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var msBaseUrl, _a, jobId, _b, limit, userId, langCode, URL_3, response, err_4;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, _a = params.jobId, jobId = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 5 : _b, userId = params.userId, langCode = params.langCode;
                URL_3 = "".concat(msBaseUrl, "/smartnavi/v2/jobs?jobId=").concat(jobId, "&limit=").concat(limit, "&user=").concat(userId, "&l=").concat(langCode);
                return [4 /*yield*/, fetch(URL_3, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': langCode
                        }
                    })];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                err_4 = _c.sent();
                console.error('getJobYouWillLove', err_4);
                return [2 /*return*/, {
                        jobs: [],
                        total: 0,
                        source: ''
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { getHotKeywords, getJobYouWillLove, getSearchBarHighLight, getSearchJob, getSuggestionKeyword, trackSuggestionKeywords };
//# sourceMappingURL=apiServices.js.map
